import "./ProfilePicture.scss";

import clsx from "clsx";
import React, { memo } from "react";

interface IProps {
  pictureUrl?: string;
  label?: string;
  firstName?: string;
  lastName?: string;
  variant?: "small" | "medium" | "large";
}

const ProfilePicture: React.FC<IProps> = memo(
  ({ pictureUrl, label, firstName, lastName, variant = "small" }) => {
    let abbr = "";
    if (firstName && lastName) {
      abbr = firstName[0].toUpperCase() + lastName[0].toLocaleUpperCase();
    } else {
      abbr = label ? label[0].toUpperCase() : "";
    }

    const pictureClassName = clsx("profile-picture", {
      "profile-picture--small": variant === "small",
      "profile-picture--medium": variant === "medium",
      "profile-picture--large": variant === "large",
    });

    return (
      <>
        {pictureUrl ? (
          <img className={pictureClassName} src={pictureUrl} />
        ) : (
          <div className={pictureClassName}>{abbr}</div>
        )}
      </>
    );
  },
);

export { ProfilePicture };
